import {
  ADD_FEATURE_START,
  ADD_FEATURE_ERROR,
  ADD_FEATURE_SUCCESS,
} from 'constants/action-types/settings/addFeature';

export default (state, { type, payload }) => {
  switch (type) {
    case ADD_FEATURE_START:
      return {
        ...state,
        addFeature: {
          loading: true,
          message: null,
          data: [],
        },
      };
    case ADD_FEATURE_ERROR:
      return {
        ...state,
        addFeature: {
          ...state.addFeature,
          error: payload,
          loading: false,
        },
      };
    case ADD_FEATURE_SUCCESS:
      return {
        ...state,
        addFeature: {
          ...state.addFeature,
          data: payload?.data,
          loading: false,
        },
      };
    default:
      return null;
  }
};
